import { pageContainerStyles as styles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPageContainer";
import { IconWrapper } from "@insite/mobius/Icon";
import { SelectPresentationProps } from "@insite/mobius/Select";
import { TextFieldPresentationProps } from "@insite/mobius/TextField";
import { TokenExFramePresentationProps } from "@insite/mobius/TokenExFrame";
import { DatePickerPresentationProps } from "@waytek/MobiusOverrides/DatePicker/DatePicker";
import { css } from "styled-components";

export const checkoutInputSelectorStyling = (
    style?:
        | SelectPresentationProps
        | DatePickerPresentationProps
        | TextFieldPresentationProps
        | TokenExFramePresentationProps,
) => ({
    labelProps: {
        ...style?.labelProps,
        size: "14px",
        lineHeight: "24px",
        weight: 600,
        css: css`
            ${style?.labelProps?.css}
            margin-bottom: 0;
        `,
    },
    hintProps: {
        ...style?.hintProps,
        css: css`
            ${style?.hintProps?.css}
            margin-top: 6px;
        `,
    },
    cssOverrides: {
        ...style?.cssOverrides,
        formInputWrapper: css`
            ${style?.cssOverrides?.formInputWrapper}
            &&&& {
                margin-top: 10px;

                ${IconWrapper} {
                    justify-content: center;
                    background: transparent;
                }
            }
        `,
    },
});
